/* eslint-disable no-unused-expressions,no-multi-assign,no-underscore-dangle,func-names,prefer-rest-params,no-plusplus,max-len,no-console,class-methods-use-this */

export const PAGE_TRACK = 'page_track';
export const EVENT_TRACK = 'event_track';
export const EVENT_LINK = 'event_link';
export const EVENT_INITIALIZED = 'event_initialized';

class Analytics {
  constructor() {
    const segmentApiKey = process.env.REACT_APP_SEGMENT_API_KEY;
    if (!segmentApiKey) {
      console.warn('no segment API key defined, integration will be disabled');
      return;
    }

    !(function () {
      const a = document.getElementsByTagName('script')[0];
      if (!a) return window.analytics;
      const analytics = window.analytics = window.analytics || [];
      if (!analytics.initialize && !analytics.invoked) {
        analytics.invoked = !0;
        analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on'];
        analytics.factory = function (t) {
          return function () {
            const e = Array.prototype.slice.call(arguments);
            e.unshift(t);
            analytics.push(e);
            return analytics;
          };
        };
        for (let t = 0; t < analytics.methods.length; t++) {
          const e = analytics.methods[t];
          analytics[e] = analytics.factory(e);
        }

        analytics.ready(() => {
          analytics.page(EVENT_INITIALIZED);
        });

        analytics.load = function (t, e) {
          const n = document.createElement('script');
          n.type = 'text/javascript';
          n.async = !0;
          n.src= `https://cdn.segment.com/analytics.js/v1/${t}/analytics.min.js`;
          a.parentNode.insertBefore(n, a);
          analytics._loadOptions = e;
        };
        analytics.SNIPPET_VERSION = '4.1.0';
      }

      analytics.load(segmentApiKey);
      return analytics;
    }());
  }

  identify(userId, attributes) {
    if (!window.analytics) return;
    window.analytics.identify(userId, attributes);
  }

  page(page) {
    if (!window.analytics) return;
    window.analytics.page(page);
  }

  event(name, attrs) {
    if (!window.analytics) return;
    window.analytics.track(name, attrs);
  }
}

export const analytics = new Analytics();
